"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ECFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_65)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_65`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 11.9789H30V17.9649H-6V11.9789Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 17.9649H30V23.9509H-6V17.9649Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 16.2105C14.2903 16.2105 16.1754 14.3254 16.1754 12C16.1754 9.67461 14.2903 7.78949 11.9649 7.78949C9.63951 7.78949 7.75439 9.67461 7.75439 12C7.75439 14.3254 9.63951 16.2105 11.9649 16.2105Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.9088 5.60699C19.9088 5.60699 18.0001 4.63857 17.5299 4.48418C17.0597 4.3298 14.0843 3.55787 14.0843 3.99295C14.0843 4.71576 13.1369 4.83506 12.9966 4.83506C12.8562 4.83506 12.8562 4.46313 11.958 4.46313C11.0597 4.46313 10.9966 4.79997 10.8492 4.79997C10.6948 4.79997 9.83164 4.7298 9.83164 3.99295C9.83164 3.62804 6.82111 4.27366 6.38603 4.48418C5.95796 4.70173 4.00708 5.60699 4.00708 5.60699C4.00708 5.60699 7.22111 5.79646 7.78954 6.04208C8.35796 6.28769 10.8632 7.19997 10.8632 7.19997L10.6667 8.1333H13.3194L13.0527 7.19997C13.0527 7.19997 15.5159 6.30874 16.1264 6.04208C16.7369 5.77541 19.9088 5.60699 19.9088 5.60699Z",
					fill: "#4C1F00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.2771 12.0491C9.2771 13.5298 10.4841 14.7369 11.9648 14.7369C13.4455 14.7369 14.6525 13.5298 14.6525 12.0491V11.2421H9.28412V12.0491H9.2771Z",
					fill: "#57BA17"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9648 7.75439C10.4841 7.75439 9.2771 8.96141 9.2771 10.4421V11.2491H14.6455V10.4421C14.6525 8.96141 13.4455 7.75439 11.9648 7.75439Z",
					fill: "#338AF3"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_65`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ECFlag };
